import dayjs from "dayjs";
import { DEFAULT_DATE_FORMAT } from "@/static/dateFormats";
import { Guid } from "@/static/guid";
import { Contractor } from "@/models/api/Contractor";
import { Expose } from "class-transformer";
import { IsDateString, IsString } from "class-validator";

export class CorrectionNote {
  @Expose()
  @IsString()
  documentId!: string; //correction note assigned to, if none - guid empty
  @Expose()
  @IsString()
  contractor!: string;
  @Expose()
  @IsString()
  addressee!: string;
  @Expose()
  @IsString()
  buyer!: string;
  @Expose()
  @IsString()
  seller!: string;
  @Expose()
  @IsString()
  invoiceNumber!: string;
  @Expose()
  @IsString()
  incorrectText!: string;
  @Expose()
  @IsString()
  correctText!: string;
  @Expose()
  @IsDateString()
  saleDate!: string;
  @Expose()
  @IsDateString()
  issueDate!: string;
  @Expose()
  @IsString()
  culture!: string;

  constructor() {
    this.documentId = Guid.Empty;
    this.contractor = "";
    this.addressee = "";
    this.buyer = "";
    this.seller = "";
    this.invoiceNumber = "";
    this.incorrectText = "";
    this.correctText = "";
    this.saleDate = dayjs().format(DEFAULT_DATE_FORMAT);
    this.issueDate = dayjs().format(DEFAULT_DATE_FORMAT);
    this.culture = "pl-PL";
  }

  static getContractorString(contractorObject: Contractor): string {
    //copied from old xtur     self.getContractorString = function (contractorObject) {
    let contractorString = contractorObject.name;
    if (contractorObject.surname !== null && contractorObject.surname.length > 0) {
      contractorString += " " + contractorObject.surname;
    }
    if (contractorObject.tin !== null && contractorObject.tin !== undefined)
      contractorString += "\nNIP: " + contractorObject.tin;
    if (contractorObject.streetAndNumber !== null && contractorObject.streetAndNumber !== undefined)
      contractorString += "\n" + contractorObject.streetAndNumber;
    if (
      contractorObject.city !== null &&
      contractorObject.city !== undefined &&
      contractorObject.postalCode !== null &&
      contractorObject.postalCode !== undefined
    )
      contractorString += "\n" + contractorObject.postalCode + " " + contractorObject.city;
    return contractorString;
  }
}
